import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SubscriptionBannerUpgradeComponent } from '@components/subscription-banner/subscription-banner-upgrade/subscription-banner-upgrade.component';
import {
  SubscriptionChangeDialogComponent
} from '@client/shared/components/subscription/subscription-change-dialog/subscription-change-dialog.component';

/**
 * Component with user's properties limit information
 */
@Component({
  selector: 'app-subscription-banner-upgrade-property',
  templateUrl: './subscription-banner-upgrade-property.component.html',
  styleUrls: ['./subscription-banner-upgrade-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SubscriptionBannerUpgradePropertyComponent {
  private dialogRef = inject(MatDialogRef<SubscriptionBannerUpgradeComponent>);
  dialog =  inject(MatDialog);

  openSubscriptionDialog(): void {
    this.dialog.open(SubscriptionChangeDialogComponent, {
      panelClass: 'dialog-extra-large',
    });

    this.dialogRef.close();
  }
}
